const Spinner: React.FC<{width: string, height:string, border: string}> = (props) => {
    return <div style={{
        border: `${props.border} solid #f3f3f3`,
        borderTop: `${props.border} solid #8A88FF`,
        borderRadius: '50%',
        width: props.width,
        height: props.height,
        animation: 'spin 1s linear infinite',
    }}></div>;
}

export default Spinner;